// extracted by mini-css-extract-plugin
export var border = "_25-8";
export var brand = "_25-t";
export var button = "_25-l";
export var center = "_25-a";
export var centered = "_25-6";
export var closeButton = "_25-c";
export var disabledWrapper = "_25-m";
export var error = "_25-p";
export var extraLarge = "_25-4";
export var extraSmall = "_25-1";
export var fill = "_25-i";
export var footer = "_25-h";
export var footerAction = "_25-j";
export var footerButtons = "_25-k";
export var header = "_25-7";
export var headerWithClose = "_25-d";
export var icon = "_25-o";
export var info = "_25-s";
export var inline = "_25-9";
export var large = "_25-3";
export var main = "_25-e";
export var modal = "_25-0";
export var nearFull = "_25-5";
export var neutral = "_25-u";
export var noPadding = "_25-g";
export var none = "_25-v";
export var scrollable = "_25-f";
export var small = "_25-2";
export var success = "_25-r";
export var tight = "_25-n";
export var titleIcon = "_25-b";
export var warn = "_25-q";